import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputNumberChangeEvent } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { confirmDialog } from "primereact/confirmdialog";

import NoDataCreated from "../../../Components/NoDataCreated";
import ErrorPage from "../../../Components/ErrorPage";
import DocumentViewModal from "../../../Components/DocumentViewModal";
import PageLoader from "../../../Components/PageLoader";
import NumberInput from "../../../Components/NumberInput";
import { goToTop } from "../../../Components/goToTop";
import { baseURL } from "../../../Api/ApiConstant";

import {
  mapMaterialTemplateCategoryTypes,
  MaterialTemplateCategoryType,
} from "../../../Controllers/Types/HeyTraderTypes/Materials/MaterialTemplateCategoryType";
import { MaterialSubCategoryType } from "../../../Controllers/Types/HeyTraderTypes/Materials/MaterialSubCategoryType";
import { MaterialTemplateType } from "../../../Controllers/Types/HeyTraderTypes/Materials/MaterialTemplateType";
import { TemplateType } from "../../../Controllers/Types/HeyTraderTypes/Materials/TemplateType";
import { MaterialPojectType } from "../../../Controllers/Types/HeyTraderTypes/Materials/MaterialPojectType";
import { createMaterialTemplate } from "../../../Api/HeyTraderService/MaterialsService";
import { useAppDispatch } from "../../../Controllers/hooks";
import { RootState } from "../../../Controllers/Store";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";

const MaterialTemplate: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useRef<Toast>(null);
  const noImageIcon = "/assets/images/icons/no_img.svg";
  const [loading, setLoading] = useState<boolean>(false);

  const loadingPage = "";
  const error = "";

  const [projectDetails, setprojectDetails] = useState<MaterialPojectType | null>(null);

  const [materialTemplateData, setMaterialTemplateData] = useState<MaterialTemplateType | null>(null);
  const [materialCategoriesData, setMaterialCategoriesData] = useState<MaterialTemplateCategoryType[]>([]);

  const [finalMaterialCategoriesData, setFinalMaterialCategoriesData] = useState<MaterialTemplateCategoryType[]>([]);

  const [selectedMaterialCategoryData, setSelectedMaterialCategoryData] = useState<MaterialTemplateCategoryType | null>(null);

  const [showDocumentViewModal, setShowDocumentViewModal] = useState<boolean>(false);
  const [showMaterialValueModal, setShowMaterialValueModal] = useState<boolean>(false);
  const [materialValue, setMaterialValue] = useState<{ [key: number]: number }>({});

  const [length, setLength] = useState<number | null>(null);
  const [width, setWidth] = useState<number | null>(null);
  const [height, setHeight] = useState<number | null>(null);
  const [lengthError, setLengthError] = useState<string>("");
  const [widthError, setWidthError] = useState<string>("");
  const [heightError, setHeightError] = useState<string>("");

  const [selectedCategory, setSelectedCategory] =
    useState<MaterialTemplateCategoryType | null>(null);

  /* Material sub category */
  const [selectedSubCategories, setSelectedSubCategories] = useState<{ [key: number]: MaterialSubCategoryType | null }>({});
  const [selectedTemplateData, setSelectedTemplateData] = useState<TemplateType | null>(null);
  const [showSubCategoryModal, setShowSubCategoryModal] = useState<boolean>(false);

  //   clieck model list
  const [templatesData, settemplatesData] = useState<TemplateType[]>([]);
  const [activeTemplate, setActiveTemplate] = useState<TemplateType | null>(null);

  const [selectedMateirlaIndex, setSelectedMateirlaIndex] = useState<number | null>(null);

  const [filteredSubCategoryData, setFilteredSubCategoryData] = useState<TemplateType[]>([]);
  const [subCategorySearchKey, setSubCategorySearchKey] = useState<string>("");
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);

  const [showCategoryModal, setShowCategoryModal] = useState<boolean>(false);
  const [filteredCategoryData, setFilteredCategoryData] = useState<MaterialTemplateCategoryType[]>([]);
  const [categorySearchKey, setCategorySearchKey] = useState<string>("");


  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const add_data = useCanEdit('Materials', 'add_materials');


  const dispatch = useAppDispatch();
  //   set selected template data
  useEffect(() => {
    if (
      location.state &&
      location.state.templateData &&
      location.state.projectData
    ) {
      const globleproject = location.state.projectData as MaterialPojectType;
      setprojectDetails(globleproject);
      setMaterialTemplateData(
        location.state.templateData as MaterialTemplateType
      );
    }
  }, [location.state]);

  // set selected template category data
  //  need applay logics
  useEffect(() => {
    if (materialTemplateData && materialTemplateData !== null) {
      setMaterialCategoriesData(materialTemplateData?.categoty_data || []);

      const transformedCategories: any =
        materialTemplateData?.categoty_data?.map((element) => {
          // Extract the first template as selectedTemplate or null if no template data exists
          const selectedTemplate =
            element.template_data && element.template_data.length > 0
              ? element.template_data[0] // First item in template_data
              : null;

          // Create the object with selectedTemplate and full template_data
          return {
            id: element.id,
            category_name: element.category_name,
            path: element.path,
            for: element.for,
            status: element.status,
            created_by: element.created_by,
            selectedTemplate: selectedTemplate, // First template or null
            template_data: element.template_data, // Full array of template_data
          };
        });

      setFinalMaterialCategoriesData(
        mapMaterialTemplateCategoryTypes(transformedCategories)
      );
    }
  }, [materialTemplateData, location.state]);

  useEffect(() => {
    if (materialCategoriesData) {
      const initialSubCategories: {
        [key: number]: MaterialSubCategoryType | null;
      } = {};
      const initialTemplateData: { [key: number]: TemplateType | null } = {};

      materialCategoriesData?.forEach((category) => {
        if (category?.template_data && category?.template_data?.length > 0) {
          initialSubCategories[category.id!] =
            category.template_data[0].material_sub_category || null;
          initialTemplateData[category.id!] = category.template_data[0] || null;

          setWidth(initialTemplateData[category.id!]?.width || 0);
          setLength(initialTemplateData[category.id!]?.length || 0);
          setHeight(initialTemplateData[category.id!]?.hight || 0);
        } else {
          initialSubCategories[category.id!] = null;
          initialTemplateData[category.id!] = null;
          setWidth(0);
          setLength(0);
          setHeight(0);
        }
      });

      setSelectedSubCategories(initialSubCategories);
    }
  }, [materialCategoriesData]);

  //   handle value updates
  //   useEffect(() => {

  //   }, [height, width, length]);

  const handleViewTemplateDocument = () => {
    setShowDocumentViewModal(true);
  };

  const handleCloseDocumentViewModal = () => {
    setShowDocumentViewModal(false);
  };

  const handleUseTemplate = () => {
    confirmDialog({
      message: "Are you sure, you want to use this template?",
      header: "Confirmation",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      accept: handleCreateUseTemplate,
      reject: () => { },
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  const handleAddCustomMaterial = () => {
    // need to parse project data.
    navigate(`/materials`, { state: { projectData: projectDetails } });
    goToTop();
  };
  //use template servic action

  const handleCreateUseTemplate = async () => {
    if (finalMaterialCategoriesData && finalMaterialCategoriesData?.length > 0) {
      const list: TemplateType[] = finalMaterialCategoriesData.map(
        (e) => e.selectedTemplate as TemplateType
      );

      const data = await createMaterialTemplate(
        materialTemplateData?.id!,
        projectDetails?.project_id!,
        list
      );

      if (data.statusCode === 200) {
        handleAddCustomMaterial();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Template used successfully.",
            life: 3000,
          });
        }
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error used template.",
            life: 3000,
          });
        }
      }
    }
  };

  /* Material value */
  const handleOpenMaterialValueModal = (
    selectedData: MaterialTemplateCategoryType,
    index: number
  ) => {
    setSelectedCategory(selectedData);
    setSelectedMateirlaIndex(index);
    setWidth(selectedData.selectedTemplate?.width!);
    setLength(selectedData.selectedTemplate?.length!);
    setHeight(selectedData.selectedTemplate?.hight!);
    setShowMaterialValueModal(true);
  };

  const handleCloseMaterialValueModal = () => {
    setShowMaterialValueModal(false);
  };

  const handleChangeMaterialValue = () => {
    // need to create function as well.
    if (selectedCategory !== null) {
      const newCollections: any = finalMaterialCategoriesData?.map((element, index) => {
        // Extract the first template as selectedTemplate or null if no template data exists
        const selectedTemplate = selectedCategory.selectedTemplate;
        // Create the object with selectedTemplate and full template_data
        if (selectedCategory.id === element.id && index === selectedMateirlaIndex) {
          return {
            id: element.id,
            category_name: element.category_name,
            path: element.path,
            for: element.for,
            status: element.status,
            created_by: element.created_by,
            selectedTemplate: {
              hight: height,
              width: width,
              length: length,
              id: selectedTemplate?.id,
              template_id: selectedTemplate?.template_id,
              category_id: selectedTemplate?.category_id,
              sub_category_id: selectedTemplate?.sub_category_id,
              status: selectedTemplate?.status,
              material_sub_category: selectedTemplate?.material_sub_category,
            }, // First template or null
            template_data: element.template_data, // Full array of template_data
          };
        } else {
          return {
            id: element.id,
            category_name: element.category_name,
            path: element.path,
            for: element.for,
            status: element.status,
            created_by: element.created_by,
            selectedTemplate: element.selectedTemplate, // First template or null
            template_data: element.template_data, // Full array of template_data
          };
        }
      });

      setFinalMaterialCategoriesData(
        mapMaterialTemplateCategoryTypes(newCollections)
      );
      setShowMaterialValueModal(false);
    }
  };

  const materialValueModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Change values</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseMaterialValueModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const materialValueModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseMaterialValueModal}
      />

      <Button
        label={`${loading ? "Processing" : "Update"}`}
        onClick={handleChangeMaterialValue}
        loading={loading}
        className="custom_btn primary"
      />
    </div>
  );

  const handleLengthChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setLength(e.value);
    }
  };

  const handleWidthChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setWidth(e.value);
    }
  };

  const handleHeightChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setHeight(e.value);
    }
  };
  /*  */

  /* Material sub category */
  const handleChangeSubCategory = (
    index: number,
    selectedTemplate: TemplateType | null,
    templateData: TemplateType[]
  ) => {

    settemplatesData(templateData);
    setActiveTemplate(selectedTemplate);
    setSelectedMateirlaIndex(index);

    setFilteredSubCategoryData(templateData);
    setShowSubCategoryModal(true);
  };

  const handleCloseSubCategoryModal = () => {
    setShowSubCategoryModal(false);
    setSubCategorySearchKey("");
  };

  const handleSelectSubCategory = (
    newTemplate: TemplateType,
    categoryId: number,

  ) => {
    // here need to creae my action.
    const newCollections: any = finalMaterialCategoriesData?.map((element, index) => {
      // Extract the first template as selectedTemplate or null if no template data exists
      const selectedTemplate = newTemplate;
      // Create the object with selectedTemplate and full template_data
      if (newTemplate.category_id === element.id && index === selectedMateirlaIndex) {
        return {
          id: element.id,
          category_name: element.category_name,
          path: element.path,
          for: element.for,
          status: element.status,
          created_by: element.created_by,
          selectedTemplate: selectedTemplate, // First template or null
          template_data: element.template_data, // Full array of template_data
        };
      } else {
        return {
          id: element.id,
          category_name: element.category_name,
          path: element.path,
          for: element.for,
          status: element.status,
          created_by: element.created_by,
          selectedTemplate: element.selectedTemplate, // First template or null
          template_data: element.template_data, // Full array of template_data
        };
      }
    });

    setFinalMaterialCategoriesData(
      mapMaterialTemplateCategoryTypes(newCollections)
    );

    setTimeout(() => {
      handleCloseSubCategoryModal();
    }, 200);
  };

  const calculateValue = (
    category: MaterialTemplateCategoryType,
    templateData: TemplateType | null
  ): number => {
    if (!templateData) return 0;
    if (category.for === "Area") {
      return (templateData.length || 0) * (templateData.width || 0);
    }
    if (category.for === "Volume") {
      return (
        (templateData.length || 0) *
        (templateData.width || 0) *
        (templateData?.hight || 0)
      );
    }
    return 0;
  };

  useEffect(() => {
    if (subCategorySearchKey) {
      setFilteredSubCategoryData(
        templatesData.filter((sub) =>
          sub.material_sub_category?.sub_category_name
            ?.toLowerCase()
            .includes(subCategorySearchKey.toLowerCase())
        )
      );
    } else {
      setFilteredSubCategoryData(templatesData);
    }
  }, [subCategorySearchKey, templatesData]);

  /* For duplicate material */
  const handleDuplicateMaterial = () => {
    // setFilteredSubCategoryData(finalMaterialCategoriesData);
    setShowCategoryModal(true);
  };

  const duplicateMaterial = () => { };

  useEffect(() => {
    if (materialCategoriesData && materialCategoriesData?.length > 0) {
      const filteredCategories = materialCategoriesData.filter((category) =>
        category
          ?.category_name!.toLowerCase()
          .includes(categorySearchKey.toLowerCase())
      );
      setFilteredCategoryData(filteredCategories);
    } else {
      setFilteredCategoryData([]);
    }
  }, [materialCategoriesData, categorySearchKey]);

  const handleCloseCategoryModal = () => {
    setShowCategoryModal(false);
    setCategorySearchKey("");
  };

  const handleSelectCategory = (category: MaterialTemplateCategoryType) => {
    let alldata: MaterialTemplateCategoryType[] = finalMaterialCategoriesData;
    let finds: MaterialTemplateCategoryType[] = finalMaterialCategoriesData.filter((e) => e.id === category.id)
    if (finds && finds.length > 0) {
      const cat = finds[0];
      alldata[alldata.length] = cat;
      setFinalMaterialCategoriesData(alldata)
    }

    setTimeout(() => {
      handleCloseCategoryModal();
    }, 200);
  };

  /* **************************** Common functions  with addd***************************** */
  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {loadingPage ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="page_breadcrumb_area">
              <ul className="page_breadcrumb">
                <li className="page_breadcrumb_item has_child">Materials</li>
                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                  Templates
                </li>
                <li className="page_breadcrumb_item active">
                  {materialTemplateData?.template_name}
                </li>
              </ul>

              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            <div className="page_header_area mt-sm-3 mt-3">
              <div className="page_action_area custom_flex">
                {(add_data) && (<button
                  className="add_data_link_btn p-ripple"
                  onClick={handleDuplicateMaterial}
                >
                  <i className="bi bi-copy"></i>
                  <span>Duplicate material</span>
                  <Ripple />
                </button>)}

                {(add_data) && (<button
                  className="add_data_link_btn p-ripple"
                  onClick={handleUseTemplate}
                >
                  <i className="bi bi-check2-circle"></i>
                  <span>Use this template</span>
                  <Ripple />
                </button>)}
              </div>

              <div className="page_action_area">
                <button
                  className="add_data_link_btn p-ripple"
                  onClick={handleViewTemplateDocument}
                >
                  <i className="bi bi-file-earmark-pdf"></i>
                  <span>View document</span>
                  <Ripple />
                </button>
              </div>
            </div>

            <div className="page_main_content_section p-sm-3 p-2">
              {finalMaterialCategoriesData &&
                finalMaterialCategoriesData?.length > 0 ? (
                <React.Fragment>
                  <Tooltip target=".change_option_btn" />
                  <div className="row material_template_list_row">
                    {finalMaterialCategoriesData?.map((category, index) => {
                      return (
                        <div
                          key={category?.id}
                          className="col-12 col-lg-12 col-xl-6"
                        >
                          <article className="material_template_list">
                            <div className="material_template_list_header">
                              <div className="material_category">
                                <div className="material_category_img_area">
                                  {category?.path ? (
                                    <img
                                      className="material_category_img"
                                      src={baseURL + category?.path}
                                      alt={category?.category_name || ''}
                                    />
                                  ) : (
                                    <img
                                      className="no_img_icon"
                                      src={noImageIcon}
                                      alt={category?.category_name || ''}
                                    />
                                  )}
                                </div>
                                <h6>{category?.category_name}</h6>
                              </div>

                              <div className="material_value_area">
                                <button
                                  className="change_option_btn icon_only p-ripple"
                                  data-pr-tooltip={`Change values`}
                                  data-pr-position="top"
                                  onClick={() => handleOpenMaterialValueModal(category, index)}
                                >
                                  <i className="bi bi-pencil-square"></i>
                                  <Ripple />
                                </button>

                                <div
                                  className="material_value_display p-ripple"
                                  onClick={() => handleOpenMaterialValueModal(category, index)}
                                >
                                  <span>
                                    {String(calculateValue(category, category.selectedTemplate!)?.toFixed(1))?.padStart(2, "0")}
                                  </span>
                                  <Ripple />
                                </div>
                                <span>
                                  {category?.for === "Area" ? "Sqm" : "Vol"}
                                </span>
                              </div>
                            </div>
                            <div className="material_template_list_footer">
                              <div
                                className="material_template_sub_category p-ripple"
                                onClick={() => handleChangeSubCategory(index, category?.selectedTemplate!, category.template_data || [])}
                              >
                                {category.selectedTemplate !== null ? category.selectedTemplate!.material_sub_category?.sub_category_name : "Select Sub Category"}
                                <Ripple />
                              </div>
                              <button
                                className="change_option_btn icon_only p-ripple"
                                data-pr-tooltip={`Change sub category`}
                                data-pr-position="top"
                                onClick={() => handleChangeSubCategory(index, category?.selectedTemplate!, category.template_data || [])}
                              >
                                <i className="bi bi-pencil-square"></i>
                                <Ripple />
                              </button>
                            </div>
                          </article>
                        </div>
                      );
                    })}
                  </div>
                </React.Fragment>
              ) : (
                <NoDataCreated
                  message={`No categories are available for this template.`}
                />
              )}
            </div>
          </div>
        )}
      </div>

      {/* View template document modal */}
      <DocumentViewModal
        isOpen={showDocumentViewModal}
        onClose={handleCloseDocumentViewModal}
        fileUrl={baseURL + materialTemplateData?.template_document!}
      />

      {/* Material value modal */}
      <Dialog
        visible={showMaterialValueModal}
        headerClassName="custom_modal_header"
        header={materialValueModalHeader}
        footer={materialValueModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseMaterialValueModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Length */}
              <div className="col-12 col-sm-6">
                <NumberInput
                  key={`length`}
                  inputId="length"
                  label="Length"
                  labelHtmlFor="length"
                  placeholder="Enter length"
                  onChange={handleLengthChange}
                  value={length}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={1}
                  error={lengthError}
                // formGroupClassName={(selectedCategory && selectedCategory?.for === 'Volume') ? '' : ' mb-sm-2'}
                />
              </div>

              {/* Width */}
              <div className="col-12 col-sm-6">
                <NumberInput
                  key={`width`}
                  inputId="width"
                  label="Width"
                  labelHtmlFor="width"
                  placeholder="Enter width"
                  onChange={handleWidthChange}
                  value={width}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={1}
                  error={widthError}
                // formGroupClassName={(selectedCategory && selectedCategory?.for === 'Volume') ? '' : ' mb-2'}
                />
              </div>

              {/* Height */}
              {selectedCategory?.for === "Volume" && (
                <div className="col-12 col-sm-6">
                  <NumberInput
                    key={`height`}
                    inputId="height"
                    label="Height"
                    labelHtmlFor="height"
                    placeholder="Enter height"
                    onChange={handleHeightChange}
                    value={height}
                    // required={selectedCategory?.for === 'Volume'}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    min={1}
                    error={heightError}
                    formGroupClassName="mb-2"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Material sub category modal */}
      <Dialog
        visible={showSubCategoryModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseSubCategoryModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"subCategorySearchKey"}
                id="subCategorySearchKey"
                value={subCategorySearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSubCategorySearchKey(e.target.value)}
                className="custom_form_input data_search_input"
                placeholder="Search subcategory by name"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {subCategorySearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setSubCategorySearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseSubCategoryModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body">
            {filteredSubCategoryData && filteredSubCategoryData?.length > 0 ? (
              <div className="data_select_option_area">
                {filteredSubCategoryData?.map((subCategory) => (
                  <div
                    key={subCategory?.id}
                    className={`data_select_option p-ripple ${subCategory?.id === activeTemplate?.id ? "selected" : ""}`}
                    onClick={() => handleSelectSubCategory(subCategory, subCategory.category_id!)}
                  >
                    <span>
                      {subCategory?.material_sub_category?.sub_category_name}
                    </span>
                    <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="no_records_found no_footer">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Duplicate material modal */}
      <Dialog
        visible={showCategoryModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseCategoryModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"categorySearchKey"}
                id="categorySearchKey"
                value={categorySearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCategorySearchKey(e.target.value)}
                className="custom_form_input data_search_input"
                placeholder="Search category by name"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {categorySearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setCategorySearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseCategoryModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body has_option">
            {filteredCategoryData && filteredCategoryData?.length > 0 ? (
              <div className="data_select_option_area">
                {filteredCategoryData?.map((category) => (
                  <div key={category?.id}
                    className={`data_select_option has_img p-ripple ${category?.id === selectedMaterialCategoryData?.id ? "selected" : ""}`}
                    onClick={() => handleSelectCategory(category)}
                  >
                    {category?.path ? (
                      <img
                        src={baseURL + category?.path}
                        className="option_image"
                        alt={category?.category_name || ''}
                      />
                    ) : (
                      <span className="option_image no_img">
                        <img src={noImageIcon} alt={category?.category_name || ''} />
                      </span>
                    )}
                    <span>{category?.category_name}</span>
                    <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="no_records_found no_footer">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default MaterialTemplate;
